import LoadingGif from "../../../assets/shared/logo_no_background_compressed.gif";

const Loader = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <img src={LoadingGif} alt="Loading" className="h-32 rounded-lg" />
    </div>
  );
};
export default Loader;
